import { SearchURLParams } from '@/interfaces/filters';
import { LIST_STATES_UF, TYPE_BIKE } from './constants';

export const getUrlOffers = (vehicleType: number, brand: string, model: string, year: string, uf: string) => {
    const vehicleTypeName = vehicleType === TYPE_BIKE ? 'motos' : 'carros';
    let queryParams = new URLSearchParams({
        tipoveiculo: vehicleTypeName,
        marca1: brand,
        modelo1: model,
        anode: year,
        anoate: year,
        page: '1',
        displayPerPage: '7',
    });
    const state = LIST_STATES_UF?.find((state) => state.value.toLowerCase() === uf.toLowerCase());
    if (state) queryParams.append('estadocidade', state!.label);
    return `${process.env.NEXT_PUBLIC_API_BASE_URL}/${vehicleTypeName}/${uf}/estoque/${brand}/${model}/de.${year}/ate.${year}?${queryParams}`;
};

export const getUFFromSearchParams = (searchParams: SearchURLParams): string => {
    const uf = searchParams?.uf as string;
    if (!uf || uf.toLowerCase() === 'br') return 'BR';
    if (searchParams?.uf) {
        const stateIsValid = LIST_STATES_UF.find((state) => state.value.toLowerCase() === uf.toLowerCase());
        if (!stateIsValid) return 'BR';
        return stateIsValid?.value;
    }
    return 'BR';
};
